<template>
    <module :type="2" v-model="showPop" :subTitle="`我的许愿票：${store.pageData?.vote_num || 0}张`">
        <taskItem
            @receiveAward="handleReceiveAward"
            @goToFinish="handleGoToFinish"
            :class="{'task-single': index !== taskInfo.length - 1}"
            v-for="(item, index) in taskInfo"
            :key="item.key"
            :taskInfo="item" />
    </module>
</template>
<script lang="ts" setup>
import {ref, computed } from 'vue';
import module from '../module/card.vue';
import taskItem from './item.vue';
import { useStore } from '@/store';
import { useStoreCommon } from '@common/store/common';
import { apiCompleteTask } from '@/http/api';
import { nativeTo, SchemaMap, jsbSupportShareSceneMap, jsbShare, schemaSupportMap, schemaToPostPublish } from '@q-front-npm/jsbridge';
import Vue from 'vue';
const store = useStore();
const storeCommon = useStoreCommon();
const emits = defineEmits(['refresh', 'share']);
const showPop = ref(false);
const taskInfo = computed(() => {
    const list = store.pageData?.task_info || [];
    return storeCommon.systemInfo.isHarmony ? list.filter(item => item.key !== 'reward') : list;
});

const handleReceiveAward = async() => {
    let count = 0;
    const promises: Promise<any>[] = [];
    taskInfo.value.forEach(item => {
        if (item.status === '2') {
            promises.push(
                apiCompleteTask({
                    activity_key: storeCommon.activityKey,
                    task_key: item.key,
                    to_status: '1',
                }).catch(err => {
                    console.error('领取许愿票失败', err);
                })
            );
            count += +item.can_finish_num;
        }
    });
    await Promise.all(promises);
    Vue.prototype.$toast(`共领取${count}张许愿票~`);
    emits('refresh');
};

// 去书架
const handleGoBookcase = () => {
    nativeTo(SchemaMap.bookShelf);
};

// 去分享
const handleGoShare = () => {
    emits('share');
};

// 去发帖
const publishTopic = (item: any, index: number) => {
    const topicInfo = store.topicList[0];
    // 鸿蒙需要走share去发帖
    store.goToTopic(topicInfo);
};

const handleGoToFinish = (info: Record<string, any>) => {
    // info.key === 'share' && (showPop.value = false);
    const finishFunc = {
        'read': handleGoBookcase,
        'reward': handleGoBookcase,
        'community': publishTopic,
        'share': handleGoShare,
    };
    console.log('info', info);
    finishFunc[info.key]?.();
};

const open = () => {
    showPop.value = true;
};

defineExpose({
    open,
});
</script>
<style lang="scss" scoped>
.task-title-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 22px 0 28px;
}
.task-title {
    font-size: 24px;
    color: #111111;
    line-height: 34px;
    .task-title-span {
        display: inline-block;
        font-weight: bold;
        position: relative;
        &::after {
            content: '';
            position: absolute;
            width: 160px;
            height: 46px;
            // background: url('@/assets/images/topic/theme_lineation.png') no-repeat center center;
            background-size: 100% 100%;
            bottom: -10px;
            right: 0;
            z-index: -1;
        }
    }
}
.task-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.task-item-card {
    margin-bottom: 16px;
    &:last-child {
        margin-bottom: 0;
    }
}
</style>
